import "./index.scss";

const UserInfoItem = ({name, value, ...props}) => {

    return (
        <>
            {name === "avatar" || name === "role"
                ? null
                : <div className="user-info-item">
                    <p>
                        {name}:
                        {
                            name === 'status'
                                ? <div className="user-info-item__status">
                                    {
                                        value
                                            ? (
                                                <div className="user-info-item__status-active">
                                                    Active
                                                </div>
                                            )
                                            : (
                                                <div className="user-info-item__status-disactive">
                                                    Not active
                                                </div>
                                            )
                                    }
                                </div>
                                : (
                                    <span>
                                {value}
                            </span>
                                )
                        }
                    </p>
                </div>
            }
            </>
    );
};

export default UserInfoItem;
